import SiYiMember from '@components/LocalMerchant/SiDa/Common/SiYiMember'
import { DECORATION_GROUP_MEMBER } from '@constant'
import { dGet } from '@core/utils'
import { isSiDaProperty } from '@merchant-backend/util'
import { Flex } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Header from '../Common/Header'
import Rowbox from '../Common/Rowbox'
import SanDaMember from './SanDaMember'
import style from './style.module.less'

/**
 * 团队成员
 */
@observer
export default class extends Component {
  render() {
    const { newThemeConfig, merchantHomeData } = this.props.store
    const groupMemberList =
      dGet(merchantHomeData, 'group_member.list', []) || []

    return (
      <Rowbox
        type={DECORATION_GROUP_MEMBER}
        store={this.props.store}
        style={{
          flexDirection: 'column',
          height: 'auto'
        }}
        vCenter={false}
      >
        {isSiDaProperty() ? (
          <Header
            title="团队成员"
            content={
              <span style={{ fontSize: 13 }}>
                全部{groupMemberList.length}位成员
              </span>
            }
          />
        ) : (
          <Header title="团队成员" />
        )}

        {groupMemberList.length > 0 &&
          (isSiDaProperty() ? (
            <Flex
              style={{
                overflow: 'hidden',
                marginRight: -16,
                marginBottom: 15
              }}
            >
              {groupMemberList.slice(0, 3).map(item => {
                return <SanDaMember key={item.id} item={item} />
              })}
            </Flex>
          ) : (
            <Flex d="v">
              {groupMemberList.map(item => {
                return (
                  <SiYiMember
                    key={item.id}
                    item={item}
                    moneyPosition="bottom"
                    nameColor={newThemeConfig['darkestText']}
                    desColor={newThemeConfig['text']}
                    priceColor={newThemeConfig['themeColor']}
                    showEmceeSchedulesCount={false}
                    className={style.member}
                    style={{
                      borderBottom: `1px solid ${newThemeConfig['splitLine']}`
                    }}
                  />
                )
              })}
            </Flex>
          ))}
      </Rowbox>
    )
  }
}
